function modeButtonClass(active) {
  return active ? "button button-primary" : "button button-light";
}

function MoneyInput({ label, value, disabled, onChange }) {
  return (
    <label className="field tariff-surcharge-value">
      <span>{label}</span>
      <input type="number" min="0" step="0.01" disabled={disabled} value={value || ""} onChange={(event) => onChange(event.target.value)} />
    </label>
  );
}

export default function SurchargeSelector({ tariff, surcharges, onChange }) {
  const updateSurcharge = (id, patch) => {
    onChange({
      ...surcharges,
      [id]: {
        ...(surcharges[id] || {}),
        ...patch,
      },
    });
  };

  const insurance = surcharges.transportInsurance || {};
  const toll = surcharges.tollAuto || {};
  const diesel = surcharges.dieselAuto || {};
  const genericDefinitions = (tariff.surchargeDefinitions || []).filter(
    (item) => !["transportInsurance", "manualDiesel", "manualToll", "dieselAuto", "tollAuto"].includes(item.id)
  );

  return (
    <div className="tariff-surcharge-list">
      <div className="tariff-surcharge-panel">
        <div>
          <strong>Versicherung</strong>
          <p className="section-text">Warenwert erfassen und automatisch laut Tarif oder manuell berechnen.</p>
        </div>
        <div className="button-row tariff-mode-row">
          <button type="button" className={modeButtonClass((insurance.mode || "none") === "none")} onClick={() => updateSurcharge("transportInsurance", { mode: "none" })}>Keine</button>
          <button type="button" className={modeButtonClass(insurance.mode === "auto")} onClick={() => updateSurcharge("transportInsurance", { mode: "auto" })}>Automatisch laut Tarif</button>
          <button type="button" className={modeButtonClass(insurance.mode === "manual")} onClick={() => updateSurcharge("transportInsurance", { mode: "manual" })}>Manuell</button>
        </div>
        <div className="tariff-surcharge-row tariff-surcharge-row-3">
          <MoneyInput label="Warenwert EUR" disabled={insurance.mode === "none"} value={insurance.goodsValue} onChange={(value) => updateSurcharge("transportInsurance", { goodsValue: value })} />
          <MoneyInput label="Manueller Betrag EUR" disabled={insurance.mode !== "manual"} value={insurance.amount} onChange={(value) => updateSurcharge("transportInsurance", { amount: value })} />
          <label className="checkbox-card tariff-checkbox">
            <input type="checkbox" checked={Boolean(insurance.overrideEnabled)} disabled={insurance.mode !== "auto"} onChange={(event) => updateSurcharge("transportInsurance", { overrideEnabled: event.target.checked })} />
            <span>Automatik manuell ueberschreiben</span>
          </label>
          {insurance.overrideEnabled && insurance.mode === "auto" && (
            <MoneyInput label="Ueberschreibung EUR" value={insurance.overrideAmount} onChange={(value) => updateSurcharge("transportInsurance", { overrideAmount: value })} />
          )}
        </div>
      </div>

      <div className="tariff-surcharge-panel">
        <div>
          <strong>Maut</strong>
          <p className="section-text">Entfernung fuer deutsche und internationale Mautanteile verwenden.</p>
        </div>
        <div className="button-row tariff-mode-row">
          <button type="button" className={modeButtonClass((toll.mode || "none") === "none")} onClick={() => updateSurcharge("tollAuto", { mode: "none" })}>Keine</button>
          <button type="button" className={modeButtonClass(toll.mode === "auto")} onClick={() => updateSurcharge("tollAuto", { mode: "auto" })}>Automatisch laut Tarif</button>
          <button type="button" className={modeButtonClass(toll.mode === "manual")} onClick={() => updateSurcharge("tollAuto", { mode: "manual" })}>Manuell</button>
        </div>
        <div className="tariff-surcharge-row tariff-surcharge-row-3">
          <label className="field tariff-surcharge-value">
            <span>Entfernung km</span>
            <input type="number" min="0" step="1" disabled={toll.mode === "none"} value={toll.distanceKm || ""} onChange={(event) => updateSurcharge("tollAuto", { distanceKm: event.target.value })} />
          </label>
          <MoneyInput label="Manueller Betrag EUR" disabled={toll.mode !== "manual"} value={toll.amount} onChange={(value) => updateSurcharge("tollAuto", { amount: value })} />
          <label className="checkbox-card tariff-checkbox">
            <input type="checkbox" checked={Boolean(toll.overrideEnabled)} disabled={toll.mode !== "auto"} onChange={(event) => updateSurcharge("tollAuto", { overrideEnabled: event.target.checked })} />
            <span>Maut manuell ueberschreiben</span>
          </label>
          {toll.overrideEnabled && toll.mode === "auto" && (
            <MoneyInput label="Ueberschreibung EUR" value={toll.overrideAmount} onChange={(value) => updateSurcharge("tollAuto", { overrideAmount: value })} />
          )}
        </div>
      </div>

      <div className="tariff-surcharge-panel">
        <div>
          <strong>Dieselzuschlag</strong>
          <p className="section-text">Aus importierter Dieseltabelle oder manuell als Prozent auf Grundfracht.</p>
        </div>
        <div className="button-row tariff-mode-row">
          <button type="button" className={modeButtonClass((diesel.mode || "none") === "none")} onClick={() => updateSurcharge("dieselAuto", { mode: "none" })}>Keine</button>
          <button type="button" className={modeButtonClass(diesel.mode === "auto")} onClick={() => updateSurcharge("dieselAuto", { mode: "auto" })}>Automatisch laut Tarif</button>
          <button type="button" className={modeButtonClass(diesel.mode === "manual")} onClick={() => updateSurcharge("dieselAuto", { mode: "manual" })}>Manuell</button>
        </div>
        <div className="tariff-surcharge-row tariff-surcharge-row-3">
          <label className="field tariff-surcharge-value">
            <span>Prozent</span>
            <input type="number" step="0.1" disabled={diesel.mode !== "manual"} value={diesel.percentage || ""} onChange={(event) => updateSurcharge("dieselAuto", { percentage: event.target.value })} />
          </label>
          <label className="checkbox-card tariff-checkbox">
            <input type="checkbox" checked={Boolean(diesel.overrideEnabled)} disabled={diesel.mode !== "auto"} onChange={(event) => updateSurcharge("dieselAuto", { overrideEnabled: event.target.checked })} />
            <span>Dieselbetrag ueberschreiben</span>
          </label>
          {diesel.overrideEnabled && diesel.mode === "auto" && (
            <MoneyInput label="Ueberschreibung EUR" value={diesel.overrideAmount} onChange={(value) => updateSurcharge("dieselAuto", { overrideAmount: value })} />
          )}
        </div>
      </div>

      {genericDefinitions.map((surcharge) => {
        const value = surcharges[surcharge.id] || {};
        const isPercentage = surcharge.type === "percentageOfBaseFreight" || surcharge.type === "percentageOfSubtotal";
        return (
          <div key={surcharge.id} className="tariff-surcharge-row">
            <label className="checkbox-card tariff-checkbox">
              <input type="checkbox" checked={Boolean(value.enabled)} onChange={(event) => updateSurcharge(surcharge.id, { enabled: event.target.checked, percentage: value.percentage || surcharge.defaultPercentage || "", amount: value.amount || surcharge.defaultAmount || "" })} />
              <span>{surcharge.label}</span>
            </label>
            <label className="field tariff-surcharge-value">
              <span>{isPercentage ? "Prozent" : "Betrag EUR"}</span>
              <input type="number" min="0" step={isPercentage ? "0.1" : "0.01"} disabled={!value.enabled} value={isPercentage ? value.percentage || surcharge.defaultPercentage || "" : value.amount || surcharge.defaultAmount || ""} onChange={(event) => updateSurcharge(surcharge.id, { [isPercentage ? "percentage" : "amount"]: event.target.value })} />
            </label>
          </div>
        );
      })}
    </div>
  );
}
